var e,t;!function(e){e[e.Prefix=0]="Prefix",e[e.Suffix=1]="Suffix"}(e||(e={})),function(e){e[e.Alternate=0]="Alternate",e[e.AlternateWithReset=1]="AlternateWithReset"}(t||(t={}));export{e as S,t as a};
//# sourceMappingURL=sort-c8713016.js.map
